import { render, staticRenderFns } from "./ClockComponent.vue?vue&type=template&id=22889ff0&"
import script from "./ClockComponent.vue?vue&type=script&lang=ts&"
export * from "./ClockComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarTitle } from 'vuetify/lib/components/VAppBar';
installComponents(component, {VAppBarTitle})
